import React, { forwardRef } from 'react';
import cn from 'classnames';
import { SIZES, LABEL_TYPES } from '../classnames';
import CLASSNAMES from './classnames';
import transition from '../../styles/transition';
import T from '../../Text';
import { getDefaultIconValues, IconItemType } from '../helpers';
import { AccentButtonProps } from './types';

const AccentButton = forwardRef<any, AccentButtonProps>(
  (
    {
      children,
      label,
      size = 'm',
      as,
      red,
      disabled,
      full,
      leftIcon: leftIconProp,
      rightIcon: rightIconProp,
      href,
      className = '',
      style,
      ...other
    },
    ref,
  ) => {
    const leftIcon: IconItemType = getDefaultIconValues(leftIconProp);
    const rightIcon: IconItemType = getDefaultIconValues(rightIconProp);
    let Tag: keyof JSX.IntrinsicElements = 'button';

    if (as) {
      Tag = as;
    } else if (href) {
      Tag = 'a';
    }

    return (
      <Tag
        className={cn(
          {
            'w-full': full,
          },
          SIZES[size],
          CLASSNAMES[
            `${red ? 'red' : 'default'}${disabled ? '-disabled' : ''}`
          ],
          className,
        )}
        style={{
          transition: transition('background-color'),
          ...style,
        }}
        disabled={disabled}
        href={href}
        ref={ref}
        {...other}
      >
        {leftIcon.component && (
          <leftIcon.component
            size={leftIcon.size}
            className={cn(
              {
                'fill-current': leftIcon.hasFill,
                'stroke-current': leftIcon.hasStroke,
              },
              disabled ? 'opacity-36' : '',
            )}
            ignoreColor
          />
        )}
        {label ? (
          <T
            type={LABEL_TYPES[size]}
            color="inherit"
            className={cn(
              {
                'ml-8': !!leftIcon.component,
                'mr-8': !!rightIcon.component,
              },
              disabled ? 'opacity-36' : '',
            )}
          >
            {label}
          </T>
        ) : (
          children
        )}
        {rightIcon.component && (
          <rightIcon.component
            size={rightIcon.size}
            className={cn(
              {
                'fill-current': rightIcon.hasFill,
                'stroke-current': rightIcon.hasStroke,
              },
              disabled ? 'opacity-36' : '',
            )}
            ignoreColor
          />
        )}
      </Tag>
    );
  },
);

export default AccentButton;
